export default function HowItWorksSection() {
  const steps = [
    {
      num: '01',
      title: 'Browse Product List',
      desc: 'Open the OOPBuy Spreadsheet and explore organized product categories with full details and pricing visible upfront.',
    },
    {
      num: '02',
      title: 'Copy Product Link or ID',
      desc: 'Find the items you want and copy the product link or item ID from the spreadsheet for your order request.',
    },
    {
      num: '03',
      title: 'Submit Order Request',
      desc: 'Send your order through the agent system with the product details you selected from the spreadsheet.',
    },
    {
      num: '04',
      title: 'Agent Confirms Details',
      desc: 'The agent verifies pricing, availability, and shipping options, then confirms everything with you before proceeding.',
    },
    {
      num: '05',
      title: 'Payment Processing',
      desc: 'Complete payment through the secure checkout system with full transparency on all costs involved.',
    },
    {
      num: '06',
      title: 'Shipping & Tracking',
      desc: 'Receive tracking updates as your order moves through processing, quality check, and international shipping.',
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-6">
            Step by Step
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-[1.15] max-w-2xl">
            How the OOPBuy Spreadsheet System Works
          </h2>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {steps.map((step) => (
            <div
              key={step.num}
              className="group rounded-2xl bg-background-100 border border-background-200/70 p-8 transition-all duration-300 hover:border-accent-300/50"
            >
              <span className="text-5xl font-heading font-bold text-accent-200 group-hover:text-accent-400 transition-colors block mb-5">
                {step.num}
              </span>
              <h3 className="text-lg font-bold text-foreground-950 mb-3">
                {step.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Process Flow Visual */}
        <div className="mt-16 flex flex-wrap items-center justify-center gap-4 text-sm text-foreground-500">
          <span className="px-4 py-2 rounded-full bg-accent-100 text-accent-800 font-semibold">Spreadsheet</span>
          <i className="ri-arrow-right-line text-accent-400"></i>
          <span className="px-4 py-2 rounded-full bg-background-100 text-foreground-600">Product Selection</span>
          <i className="ri-arrow-right-line text-accent-400"></i>
          <span className="px-4 py-2 rounded-full bg-background-100 text-foreground-600">Agent Processing</span>
          <i className="ri-arrow-right-line text-accent-400"></i>
          <span className="px-4 py-2 rounded-full bg-background-100 text-foreground-600">Payment</span>
          <i className="ri-arrow-right-line text-accent-400"></i>
          <span className="px-4 py-2 rounded-full bg-background-100 text-foreground-600">Shipping Tracking</span>
        </div>

        {/* Micro CTA */}
        <div className="mt-12 text-center">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 hover:bg-primary-600 transition-colors text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer"
          >
            Try Spreadsheet System Now
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}